angular.module('bookAndPay').controller('ProcessPaymentCtrl', ["$scope", "$rootScope", "$state", "$window", "$http", "$interval", "DataService", "Restangular", "CreditCardExpirationDatesService", "BookAndPayService", "flash", "cart", function($scope, $rootScope, $state, $window, $http, $interval, DataService, Restangular, CreditCardExpirationDatesService, BookAndPayService, flash, cart) {
  var intervalId;
  $scope.cart = cart.plain();
  $scope.currency = DataService.currency;
  $scope.years = CreditCardExpirationDatesService.getYears();
  $scope.months = CreditCardExpirationDatesService.getMonths();
  $scope.cartType = cart.cart_type === 'payment_only_cart' ? 'po' : void 0;
  $scope.isIntegrapay = cart.realtime_payment_provider === 'integrapay';
  $scope.isEzidebit = cart.realtime_payment_provider === 'ezidebit';
  $scope.isStripe = cart.realtime_payment_provider === 'stripe';
  $scope.expired = BookAndPayService.isExpired($scope.cart);
  intervalId = $interval(function() {
    return $scope.expired = BookAndPayService.isExpired($scope.cart);
  }, 1000);
  $scope.$on('$destroy', function() {
    return $interval.cancel(intervalId);
  });
  $scope.setLoading = function(loading) {
    var confirmText;
    $scope.isLoading = loading;
    if (loading) {
      confirmText = 'Please wait while your payment is being processed.';
      $rootScope.stateChangeConfirmMessage = confirmText;
      return $window.onbeforeunload = function(e) {
        e.returnValue = confirmText;
        return confirmText;
      };
    } else {
      $rootScope.stateChangeConfirmMessage = void 0;
      return $window.onbeforeunload = void 0;
    }
  };
  if ($scope.isEzidebit) {
    $http.get(`/fee_schedules?gym_id=${DataService.gym_id}&for_book_and_pay=1`).then(function(response) {
      return $scope.fees = response.data.fees;
    });
  }
  $scope.displayTime = function() {
    return moment(cart.event_start_at, 'YYYY/MM/DD HH:mma').format('ddd, D MMM [at] h:mm');
  };
  $scope.toNewCart = function() {
    return $state.go('bookAndPay.newCart', {
      uuid: cart.membership_plan_uuid,
      ct: $scope.cartType
    });
  };
  $scope.cancelBooking = function() {
    if ($window.confirm("Are you sure you want to cancel your booking?")) {
      return $scope.toNewCart();
    }
  };
  return $scope.onPaymentsUnavailable = function() {
    return $scope.paymentsUnavailable = true;
  };
}]);
